import { FC, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Typography } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { EasTableWithoutFilter } from 'ui/EasTableWithoutFilter';
import { THandleAction } from 'ui/EasTable/types';
import { TPageResponse } from 'redux/types';
import { getPrintLabelsRequest, clearPrintLabels } from 'redux/reducers/euDdp/reducer';
import { selectPrintLabels, selectPrintLabelsLoading } from 'redux/reducers/euDdp/selectors';
import { tableStructure } from './tableStructure';
import { TPrintLabelsTableItem } from './types';

export const PrintLabelsList: FC = () => {
	const dispatch = useDispatch();
	const labels = useSelector(selectPrintLabels);
	const loading = useSelector(selectPrintLabelsLoading);

	useEffect(() => {
		dispatch(getPrintLabelsRequest());
		return () => {
			dispatch(clearPrintLabels());
		};
	}, [dispatch]);

	const handlePrint = () => window.print();

	const handleAction: THandleAction = useCallback(() => {}, []);

	const tableData: TPageResponse<TPrintLabelsTableItem> | null = !labels
		? null
		: {
				data: labels.map((label) => ({ ...label, id: label.rowNumber })),
				pageNumber: 1,
				pageSize: labels.length,
				totalCount: labels.length,
			};

	return (
		<Box sx={{ p: 2 }}>
			<style>
				{`@media print {
					.no-print { display: none !important; }
					@page { size: A4; margin: 12mm; }
					body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
				}`}
			</style>

			<Box
				className="no-print"
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					mb: 2,
				}}
			>
				<Typography variant="h6" color="primary" fontWeight="bold">
					EU DDP Labels List
				</Typography>
				<Button
					variant="contained"
					color="primary"
					size="small"
					startIcon={<PrintIcon />}
					onClick={handlePrint}
					disabled={loading || !labels?.length}
				>
					Print
				</Button>
			</Box>

			<EasTableWithoutFilter<TPrintLabelsTableItem>
				tableStructure={tableStructure}
				items={tableData}
				itemsIsLoading={loading}
				handleAction={handleAction}
				skeletonRows={[1, 2, 3]}
			/>
		</Box>
	);
};
